import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';

export const salesforceCallback = ({ code, state }) => {
  return axios.post(`/api/v1/integration/salesforce/oauth/callback`, {
    code,
    state,
  });
};

export const useSalesforceCallback = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation(salesforceCallback, {
    onError: () => {
      addNotification({
        type: 'error',
        title: 'Salesforce Connection Failed',
      });
    },
    ...config,
  });
};
